import React, { Component } from 'react'
import EventCards from './events/EventCards'
import {db} from '../config/fbConfig'
import './events/events.css'


class Events extends Component {

    state={
        events:''
    }

    componentDidMount(){
        db.collection('events').get()
        .then(snapshot=>{
            const Events = []
            snapshot.forEach(doc=>{
                const data = doc.data()
                console.log(data)
                Events.push(data)
                console.log(Events)
            })
            this.setState({events:Events})
            console.log(this.state.events)
        })
    }

    render() {
        return (
            <div className='event-wrapper'>
            <h1>Participate in events!</h1>
            <div className='events-container'>
            {
                this.state.events && this.state.events.map(event=>{
                    return(
                        <EventCards event={event}/>
                    )
                })
            }
            </div>
            </div>
        )
    }
}

export default Events

